import React from "react";
import "./FooterRoutes.css"; // Using FooterRoutes.css for styling

export default function PrivacyPolicy() {
  return (
    <div className="container">
      <h1 className="title">Privacy Policy</h1>

      <div className="section">
        <p>
          Thank you for visiting us. Your privacy is important to us, and we are committed to protecting and safeguarding your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect your information when you use our website and services.
        </p>
        <p>
          By accessing or using our website, you consent to the practices described in this Privacy Policy. Please take a moment to review this policy and contact us if you have any questions.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Information We Collect</h2>

        <h3 className="step-title">Personal Information</h3>
        <p>
          When you create an account or make a purchase, we may collect personal information such as your name, email address, shipping address, and phone number.
        </p>
        <ul>
          <li>
            Payment information, including credit card details, is securely processed by our payment service providers, and we do not store such information on our servers.
          </li>
        </ul>

        <h3 className="step-title">Non-Personal Information</h3>
        <p>
          We may collect non-personal information, such as your IP address, browser type, and device information, to enhance our website's functionality and improve user experience.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">How We Use Your Information</h2>
        <p>We use the collected information for the following purposes:</p>
        <ul>
          <li>To process and fulfill your orders, including shipping and customer support.</li>
          <li>To personalize your shopping experience and improve our website.</li>
          <li>To communicate with you regarding your orders, promotions, and updates.</li>
          <li>To prevent fraud and ensure the security of our website and users.</li>
          <li>To comply with legal obligations.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">Information Sharing</h2>
        <p>
          We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except for the following purposes:
        </p>
        <ul>
          <li>
            <strong>Service Providers:</strong> We may share information with trusted third-party service providers who assist us in operating our website, conducting business, and serving you.
          </li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">Security</h2>
        <p>
          We implement reasonable security measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Cookies and Tracking Technologies</h2>
        <p>
          We use cookies and similar tracking technologies to enhance your experience on our website. You can manage your cookie preferences through your browser settings.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these websites. We encourage you to review the privacy policies of these third parties.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Children's Privacy</h2>
        <p>
          Our website is not directed at children under 13, and we do not knowingly collect personal information from children. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us, and we will take steps to delete such information.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time, and the updated version will be effective when posted on our website. We encourage you to check this page periodically for changes.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Contact Us</h2>
        <p>
          If you have any questions or concerns about our Privacy Policy, please contact us at <a href="mailto:support@spectsgenie.com">support@spectsgenie.com</a>.
        </p>
        <p>Thank you for trusting us.</p>
      </div>
    </div>
  );
}
